import {Option} from 'platform/components';

import {BillingInformationListItemResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

type BillingInformationLabelKey = 'billingName' | 'companyName';

interface GetBillingInformationOptionsParams {
  billingInformations: BillingInformationListItemResponseBody[] | Nullish;
  /** Current value of the field; a deactivated entry stays visible only while it is selected. */
  selectedId: string | Nullish;
  labelKey: BillingInformationLabelKey;
}

export const getBillingInformationOptions = (
  params: GetBillingInformationOptionsParams
): Option[] =>
  (params.billingInformations ?? [])
    .filter(
      (billingInformation) =>
        billingInformation.active || billingInformation.id === params.selectedId
    )
    .map((billingInformation) => {
      const fallbackKey = params.labelKey === 'companyName' ? 'billingName' : 'companyName';
      const label = billingInformation[params.labelKey] ?? billingInformation[fallbackKey] ?? '';

      return {
        value: billingInformation.id,
        label: billingInformation.active
          ? label
          : i18n.t('general.labels.deactivatedOptionLabel', {label}),
      };
    });
